import { render, staticRenderFns } from "./BatchdetailReport.vue?vue&type=template&id=6112aa1c"
import script from "./BatchdetailReport.vue?vue&type=script&lang=js"
export * from "./BatchdetailReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports